import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Tag} from "../tags/types.ts";

export type MessageDimension = { name: string, value: string }

export enum MessageStatus {
    READ = 'READ',
    UNREAD = 'UNREAD',
    SENT = 'SENT',
    DELETED = 'DELETED',
    ARCHIVED = 'ARCHIVED',
}

export type Message = {
    id: string,
    messageId?: string,
    from?: string[],
    fromText?: string,
    fromHtml?: string,
    to?: string[],
    toText?: string,
    toHtml?: string,
    subject?: string,
    date?: string,
    parsedPath?: string,
    parsedObjectKey?: string,
    htmlPath?: string,
    htmlObjectKey?: string,
    textPath?: string,
    textObjectKey?: string,
    textAsHtmlPath?: string,
    textAsHtmlObjectKey?: string,
    attachments?: { filename: string, filePath: string, objectKey: string }[],
    status?: MessageStatus,
    aliasId?: string,
    tagIds?: string[],
    tags?: { items: Tag[] | null },
    inReplyTo?: string,
    createdByUsername?: string,
    managedByUsername?: string,
    created?: string,
    updated?: string,
}


export interface IMessageTableColumn extends ITableColumn {
    render?: (item: Message) => ReactNode;
}

export type ListMessages = {
    listMessages: { items: Message[], nextToken: string | null }
}

export type GetMessage = {
    getMessage: Message
}

export type CreateMessage = {
    createMessage: Message
}

export type UpdateMessage = {
    updateMessage: Message
}

export type DeleteMessage = {
    deleteMessage: string
}
